<style>
.message-bubble {
	max-width: 80%;
	padding: 0.5rem 0.75rem;
	border-radius: 0.75rem;
	word-wrap: break-word;
}

.message-bubble-incoming {
	background-color: #e9ecef;
	border-bottom-left-radius: 0.25rem;
}

.message-bubble-outgoing {
	background-color: #0d6efd;
	color: #fff;
	border-bottom-right-radius: 0.25rem;
}
.message-bubble-outgoing .message-meta {
	text-align: right;
}
.message-content {
	font-size: 0.9rem;
	line-height: 1.4;
	white-space: pre-wrap;
}

.message-item {
	display: flex;
	margin-bottom: 0.75rem;
}
.message-item-incoming {
	justify-content: flex-start;
}
.message-item-outgoing {
	justify-content: flex-end;
}
.message-meta {
	font-size: 0.7rem;
	margin-top: 0.25rem;
	opacity: 0.7;
}
.message-phone {
	font-weight: 500;
}
</style>
<template>
	<div
		class="message-item"
		:class="isOwn(message) ? 'message-item-outgoing' : 'message-item-incoming'"
	>
		<div
			class="message-bubble"
			:class="
				isOwn(message) ? 'message-bubble-outgoing' : 'message-bubble-incoming'
			"
		>
			<div class="message-content">
				{{ message.content }}
			</div>
			<div class="message-meta">
				<TimeRelative :time="message.created" />
				<span
					v-if="message.source && message.destination"
					class="message-phone"
				>
					&middot;
					{{ isOwn(message) ? "to" : "from" }}
					{{ isOwn(message) ? message.destination : message.source }}
				</span>
			</div>
		</div>
	</div>
</template>
<script setup lang="ts">
import TimeRelative from "@/components/TimeRelative.vue";
import { Message } from "@/type/api";
interface Props {
	message: Message;
}
const props = defineProps<Props>();
function isOwn(message: Message): boolean {
	return message.source === "nidus";
}
</script>
